import { IGradeStatus } from '@northladder/services';

import { formatStatus } from './utils';

import {
  IGradeDealsSearchRawData,
  IGradeReviewList,
  IGradeReviewRequestListResponseData,
} from '../../types';

/**
 * Formatter to transform the `raw grade deal search request list API response`
 * to IGradeReviewRequestListResponseData
 */
export function formatRequestGradeDealsSearchResponse(
  response: IGradeDealsSearchRawData
): IGradeReviewRequestListResponseData {
  const { appraisals, totalCount } = response || {};
  const gradeList: IGradeReviewList[] = appraisals.map((deliveredDevices) => {
    const {
      appraisalCode,
      appraisalStatus,
      brandName,
      dealPrice,
      deliveredOn,
      isAutomatedAssessment,
      label,
      paymentType,
      saleGrade,
      serialNumber,
      status,
      validationErrors,
    } = deliveredDevices || {};

    const formattedGradeStatus = formatStatus(status);

    let displayStatus = [appraisalStatus];

    if (paymentType) {
      displayStatus = [paymentType, ...displayStatus];
    }

    return {
      appraisalCode,
      assetName: label,
      serialNumber,
      gradeCondition: saleGrade,
      brandName,
      gradeReviewRequestId: '',
      date: deliveredOn,
      gradeReviewTicketNumber: '',
      displayStatus,
      gradeStatus: deliveredOn
        ? IGradeStatus.DEVICE_DELIVERED
        : IGradeStatus.NONE,
      gradeStatusName: formattedGradeStatus,
      purchasePrice: dealPrice,
      validateErrorMessages: validationErrors,
      isAutomatedAssessment,
      isCreatedByNL: false,
    };
  });

  return {
    gradeList,
    count: totalCount,
    gradeFilterOptions: [],
  };
}
